export const portugueseTranslations = {
  locale: 'pt-BR',
  direction: 'ltr',
  text: {
    loginStageOneLink: 'Usar domínio personalizado',
    loginStageTwoForgotPassword: 'Esqueceu a senha?',
    footerText:
      'Direitos autorais © 2005-2024 NICE LTD | inContact, Inc. Todos os direitos reservados.',
    footerTextLink: 'Contate-nos',
    welcomeToAgeOfAI: 'Bem-vindo à Era da IA para CX',
    ourServices:
      'Temos soluções de IA específicas que estão transformando empresas',
    webinarsDescription1: `Nossa série de webinars sob demanda em 5 partes com os principais especialistas em IA mostrará por que a IA criada em CX revolucionará a forma como seus clientes, funcionários e executivos interagem com sua marca.`,
    webinarsDescription2: `Nossos webinars abordam o desafio específico de uma parte interessada crítica do negócio e fornecem estratégias acionáveis para implantar IA focada na experiência do cliente. Essas sessões de webinar estão prontas para ajudá-lo a transformar seu CX por meio do poder da IA`,
    contactCardAddress: 'Endereço',
    contactCardHistory: 'Histórico de contato',
    viewMore: 'Ver {x} Mais',
    assignments: 'Caixa de entrada',
    noAssignments: 'Sem atribuições',
    export: 'Exportar',
    exportFormat: 'Formato de exportação',
    assignTo: 'Atribuir a',
    accept: 'Aceitar',
    reject: 'Rejeitar',
    markAsResolved: 'Marcar como resolução',
    save: 'Salvar',
    dockControls: 'Controles de doca',
    pinControls: 'Controles de pinos',
    addChannel: 'Adicionar canal',
    hold: 'Segurar',
    resume: 'Retomar',
    mute: 'Mudo',
    unmute: 'Ativar som',
    mask: 'Máscara',
    unmask: 'Desmascarar',
    end: 'Fim',
    recording: 'Gravação',
    transfer: 'Consultar/Transferir',
    transferContact: 'Transferência',
    commit: 'Cometer',
    consult: 'Consultar',
    hungup: 'Desligar',
    record: 'Registro',
    keypad: 'Teclado numérico',
    contactControls: 'Controles de contato',
    goAvailable: 'Ir Disponível',
    myProfile: 'Meu perfil',
    favorites: 'Favoritos',
    allCodesX: 'Todos os códigos ({x})',
    logOut: 'Sair',
    participantX: 'Participantes ({x})',
    waitingOnHold: 'Esperando em espera',
    inConsult: 'Em Consulta',
    Ringing: 'Zumbido',
    Conference: 'Conferência',
    Consult: 'Consultar',
    agentSearchBox: 'Pesquise pessoas, habilidades, equipes, etc.',
    available: 'Disponível',
    unavailable: 'Indisponível',
    working: 'Trabalhando',
    noAgentFound: 'Nenhum agente encontrado.',
    myTeam: 'Minha equipe',
    appSpace: 'Espaço do aplicativo',
    contactCard: 'Cartão de Visita',
    schedule: 'Horário',
    calendar: 'Calendário',
    directory: 'Diretório',
    sentiment: 'Sentimento',
    enlighten: 'Iluminar',
    wem: 'WEM',
    quickReply: 'Respostas rápidas',
    account: 'Conta',
    home: 'Casa',
    assign: 'Atribuir',
    assignment: 'Designação',
    queue: 'Fila',
    appHealth: 'Integridade do aplicativo',
    settings: 'Configurações',
    entry: 'Entrada',
    entries: 'Entradas',
    show: 'Mostrar',
    hide: 'Esconder',
    hideAllDetails: 'Ocultar todos os detalhes',
    hidden: 'Escondido',
    unhide: 'Reexibir',
    delete: 'Excluir',
    search: 'Procurar',
    all: 'Todo',
    overall: 'Geral',
    inbound: 'Entrada',
    outbound: 'Saída',
    addEdit: 'Adicionar / Editar',
    viewLess: 'Ver menos',
    channels: 'Canais',
    cellphone: 'Celular',
    whatsapp: 'Whatsapp',
    twitter: 'Gorjeio',
    minimizePanel: 'Painel Minimizar',
    newBrowserWindow: 'Criar nova janela do navegador',
    rtaActiveTooltipMessage:
      "Analyzing the Patron's voice and comparing to their enrolled voiceprint.",
    rtaAuthenticatedTooltipMessage:
      'A identidade do Patrono foi autenticada com sucesso usando CXone RTA.',
    rtaNotAuthenticatedTooltipMessage:
      "The Patron's identity was not authenticated by using CXone RTA.",
    rtaMissingPatronIdTooltipMessage: 'ID for the Patron is required for RTA.',
    rtaListeningStatus: 'Listening to Patron ID',
    rtaDialogTitle: 'RTA Enrollment',
    enroll: 'Enroll',
    cancel: 'Cancelar',
    discard: 'Discard',
    launch: 'Lançar',
    controlPosition: 'Posição de controle',
    sms: 'SMS',
    email: 'Email',
    addNewChannel: 'Adicionar novo canal',
    outcomes: 'Resultados',
    allQuickReplies: 'All Quick Replies',
    publicTweet: 'Public Tweet',
    deleteTweet: 'Excluir Tweet',
    age: 'Idade',
    timezone: 'Fuso horário',
    companySize: 'Company Size',
    replyingTo: 'Respondendo a',
    viewDetails: 'Ver detalhes',
    hideDetails: 'Ocultar detalhes',
    viewOriginalTweet: 'Ver Tweet Original',
    hideOriginalTweet: 'Ocultar Tweet Original',
    viewRepliesTweet: 'Ver Respostas ao Tweet',
    hideRepliesTweet: 'Ocultar Respostas ao Tweet',
    callRejected: 'Call Rejected',
    digitalInteractionRejected: 'Indeferido',
    requestInteraction: 'Solicitar interação',
    newOutbound: 'Nova Saída',
    requestingInteraction: 'Requesting Interaction',
    quickChatPlaceHolder: 'Enter Message Here',
    conversations: 'Conversations',
    noMatchesFound: 'No Matches Found',
    addSms: 'Adicionar SMS',
    addEmail: 'Adicionar e-mail',
    back: 'Voltar',
    reloadApplication: 'Recarregar aplicativo',
    agentName: 'Nome do agente',
    agentId: 'ID do agente',
    stationId: 'ID da estação',
    phoneNumber: 'Número de telefone',
    callerId: 'ID do chamador',
    browserVersion: 'Versão do navegador',
    browserLanguage: 'Idioma do navegador',
    currentContacts: 'Current Contacts',
    displayedUsername: 'Nome de usuário exibido',
    version: 'Versão',
    sessionId: 'ID da sessão',
    agentLegId: 'ID da perna do agente',
    agentLeg: 'Perna do Agente',
    webServer: 'Servidor Web',
    virtualCluster: 'Virtual Cluster',
    browserLocalization: 'Localização do navegador',
    currentTimezone: 'Hora atual e fuso horário',
    contactLimit: 'Limite de corrente',
    totalLimit: 'Limite total',
    reqContact: 'Solicitar contato',
    contactAutoFocus: 'Foco automático de contato',
    teamName: 'Nome da equipe',
    routing: 'Roteamento',
    enabled: 'Enabled',
    disabled: 'Disabled',
    viewOriginalPost: 'Ver postagem original',
    hideOriginalPost: 'Ocultar postagem original',
    viewRepliesPost: 'Ver Respostas à Postagem',
    hideRepliesPost: 'Ocultar Respostas à Postagem',
    publicComment: 'Comentário público',
    next: 'Próximo',
    signInHeader: 'Faça login no CXone',
    userName: 'Nome de usuário',
    password: 'Senha',
    backButtonText: 'Voltar',
    signInButtonText: 'Entrar',
    rememberMe: 'Lembre-se de mim',
    voicePreferences: 'Preferências de voz',
    rememberPreference: 'Lembrar preferência',
    viewAll: 'Ver tudo',
    viewAllDetails: 'Ver todos os detalhes',
    favorties: 'Favoritas',
    confirmationNumber: 'Número de confirmação',
    allQReplies: 'Todas as respostas rápidas',
    replyToPreviousComment: 'Esta é uma resposta a um comentário anterior',
    loginAndVoicePreference: 'Login e preferências de voz',
    avNotifications: 'Notificações A/V',
    displayAndAccessability: 'Exibição e acessibilidade',
    favortie: 'Favourite',
    notFavorite: 'Not Favourite',
    notifications: 'Notificações',
    screenPop: 'Screen Pop',
    invalidPhoneNumber: 'Invalid Phone Number',
    invalidStationId: 'Invalid Station ID',
    agentStateUpNext: 'Up Next',
    agentStateNextNext: 'After That',
    cxoneAgentAvailable:
      'CXone Agent is only available for business units using Omnichannel Session Handling (OSH) routing and User Hub administration.',
    voicePermissionUnavailable:
      'Unable to login. This user does not have permissions for any voice connection options.',
    logIn: 'Log In',
    backToLogin: 'Back to Login',
    inboundContact: 'Contato de entrada',
    outboundContact: 'Contato de saída',
    inboundConsult: 'Consulta de Entrada',
    outboundConsult: 'Consulta de saída',
    dialer: 'Dialer',
    dialerPending: 'Dialer Pending',
    loggedOut: 'Logged Out',
    agentLegConnected: 'Agent leg connected.',
    agentLegDisconnected: 'Perna do agente desconectada.',
    agentLegDialing: 'Discagem de trechos do agente.',
    clickToConnect: 'Clique para conectar.',
    clickToDisconnect: 'Clique para desconectar.',
    skills: 'Habilidades',
    skillQueue: 'Queue',
    skillWait: 'Wait',
    includeExternalDir: 'Include external directories',
    externalDirectorylabel: 'External Directories',
    on: 'On',
    off: 'Off',
    invalidAgentid: 'Invalid Agent Id.',
    phoneNumberInUseGeneric:
      'The phone number you entered is already in use.  You must enter a different phone number.',
    phoneNumberInUse:
      'The phone number is currently in use by another agent. Try again later or use a different phone number.',
    stationIdInUseGeneric:
      'The Station ID you entered is already in use.  You must enter a different Station ID.',
    stationIdInUse:
      'The Station ID is currently in use by another agent. Try again later or use a different Station ID.',
    phoneNumberInUseLessThanSevenDigits:
      'Please enter your full phone number, including extension, if applicable.',
    agentOrStationLimitExceeded:
      'Concurrent agent limit or station limit exceeded.',
    unauthorized: 'Unauthorized',
    insufficientPermissions: 'Insufficinet Permissions',
    sessionInProgress: 'Session in Progress',
    invalidSessionTimeout:
      'Invalid session timeout value.  Timeout value must be 30 to 300, or 0 for default.',
    stationLimitExceeded: 'Station Limit Exceeded',
    minutes: 'min',
    setPhoneNumber: 'Definir número de telefone',
    setStationID: 'Definir ID da estação',
    stationID: 'ID da estação',
    integratedSoftPhone: 'Softphone integrado',
    teams: 'Teams',
    members: 'members',
    voiceCall: 'Voice Call',
    close: 'Close',
    contactHistory: 'Histórico de contato',
    customerCard: 'Customer Card',
    call: 'Call',
    loading: 'Loading',
    loadMore: 'load more...',
    subject: 'Assunto',
    damagedLuggageClaim: 'Reclamação de bagagem danificada',
    searchResults: 'Search Results',
    frequentlyUsed: 'Frequently Used',
    smileysAndEmotions: 'Smileys & Emotion',
    peopleAndBody: 'People & Body',
    animalAndNature: 'Animals & Nature',
    foodAndDrink: 'Food & Drink',
    activity: 'Activity',
    travelAndPlaces: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    noEmojiFound: 'No Emoji Found',
    defaultSkinTone: 'Default skin tone',
    lightSkinTone: 'Light skin tone',
    mediumLightSkinTone: 'Medium light skin tone',
    mediumSkinTone: 'Medium skin tone',
    mediumDarkSkinTone: 'Medium dark skin tone',
    darkSkinTone: 'Dark skin tone',
    chat: 'Bater papo',
    Chat: 'Bater papo',
    Email: 'Email',
    messages: 'Mensagens',
    li: 'LinkedIn',
    Linkedin: 'LinkedIn',
    Facebook: 'Facebook',
    fb: 'Facebook',
    telegram: 'Telegram',
    Insta: 'Instagram',
    tw: 'Twitter',
    Twitter: 'Gorjeio',
    yt: 'YouTube',
    interaction: 'Interaction',
    completed: 'completed',
    week: 'Semana',
    day: 'Dia',
    mySchedule: 'Minha Agenda',
    ShiftBidding: 'Shift Bidding',
    ScheduleRequests: 'Solicitações de Agenda',
    Evaluations: 'Avaliações',
    RecentInteractions: 'Interactions Recentes',
    private: 'Private',
    more: 'Mais',
    forward: 'Forward',
    replyAll: 'Reply All',
    agents: 'Agents',
    from: 'De',
    invalidEmailAddress: 'Invalid Email Address',
    contactCardDetails: 'Details',
    outcome: 'Outcome',
    mediaDeviceAccessDenied:
      'Application access to the media device such as headset, microphone or speaker is denied.',
    mediaDeviceAccessDeniedSubMsg:
      'Click the blocked icon in your browser address bar and select Always allow access to microphone',
    error: 'Error',
    leaveConference: 'Leave Conference',
    logOutConfirmationTitle: 'Log out Confirmation',
    logOutConfonfirmationMsg: 'Are you sure you want to log out?',
    emailToolTip: 'Enter valid Email Address here',
    textToolTip: 'Enter text here',
    noInformationAvailable: 'No information Available',
    allowMicrophonePermissionInstruction:
      "Click the blocked icon in your browser address bar and select 'Always allow access to microphone'",
    bcc: 'CCO',
    cc: 'CC',
    to: 'PARA',
    conference: 'Conference',
    calender: 'Calender',
    send: 'Enviar',
    preview: 'Visualização',
    today: 'Hoje',
    open: 'Abrir',
    closed: 'Fechado',
    resolved: 'Resolvido',
    unassign: 'Unassign & Dismiss',
    showOrigin: 'Show origin',
    notificationCount: 'You have {0} New Notification(s)',
    noNewNotification: 'No New Notifications',
    autoAccept: 'Aceitação automática',
    clientSettingsTabs: 'client settings tabs',
    delaySeconds: 'Delay Seconds',
    display: 'Display',
    endLiveContact: 'End Live Contact',
    newAgentMessage: 'Nova mensagem do agente',
    newContact: 'Novo contato',
    audioNotifications: 'Notificações de áudio',
    visualNotifications: 'Notificações visuais',
    visualEndContact: 'Encerrar bate-papo ou contato',
    newContactReply: 'Novo contato Resposta',
    endChatOrCall: 'Encerrar bate-papo ou chamada',
    notification: 'Notificação',
    playRingtone: 'Tocar toque',
    ringTone: 'Toque',
    secondaryDevice: 'Dispositivo Secundário',
    secondaryRinger: 'Campainha Secundária',
    softPhone: 'Softphone',
    twentyFourHourTime: '24 hour time',
    voice: 'Voz',
    Voice: 'Voz',
    Voicemail: 'Correio de voz',
    VideoCall: 'Chamada de vídeo',
    ccfCustomerCardinputHelperText: 'invalid %s',
    dnis: 'DNIS',
    skillname: 'NOME DA HABILIDADE',
    badNumberCalledErrorText: 'Dialed number is invalid',
    recipient: 'Recipient',
    message: 'Message',
    pastTimeStamp: 'ago',
    closedInteraction: 'You are viewing a closed interaction',
    clear: 'Clear',
    ig: 'Instagram',
    insert: 'Insert',
    fwd: 'Fwd',
    re: 'Re',
    avatar: 'Avatar',
    emptyHelperText: 'Empty/Invalid %s',
    noRecordsFound: 'No Records Found',
    loadingIndicator: 'Loading data... Please wait',
    edit: 'Editar',
    longestWait: 'ESPERA MAIS LONGA',
    skillDetails: 'Detalhes da habilidade',
    activeQueue: 'Fila ativa',
    contacts: 'Contatos',
    channel: 'canal',
    wait: 'Esperar',
    agentsAssigned: 'AGENTE ATRIBUÍDO',
    channelTypes: 'TIPOS DE CANAL',
    totalContacts: 'TOTAL DE CONTATOS',
    caseStatusChanged: 'Case status changed to {x} successfully',
    unableToChangeCaseStatus: 'Unable to change case status #{x}',
    unableToUnassignCase: 'Unable to unassign case #{x}',
    caseUnassigned: 'Case - {x} unassigned successfully',
    fileSize40Mb: 'File size exceeded than allowed limit of 40MB',
    fileSize0Mb: '0 byte file size, not allowed to upload',
    newMessage: 'New Message',
    skillSelect: 'Select a skill',
    channelSelect: 'Select a channel',
    ignore: 'Ignore',
    Post: 'Postar',
    tweet: 'Tweet',
    chatContactMode: 'Chat',
    mail: 'Mail',
    smsContactMode: 'Sms',
    activeContactsInQueue:
      'You currently have active contacts. Are you sure you want to log out?',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    bulletedList: 'Bulleted List',
    numberedList: 'Numbered List',
    leftAlign: 'Left Align',
    rightAlign: 'Right Align',
    centerAlign: 'Center Align',
    clearReply: 'Clear drafted reply',
    discardReply: 'Discard drafted reply',
    addAttachment: 'Attach files',
    addEmoji: 'Emoji',
    unableToTransferDigitalSkill: 'Unable to transfer digital skill',
    unableToTransferDigitalContact: 'Unable to transfer digital contact',
    outboundReplyError: 'Unable to send reply/outbound: {x}',
    outboundReplyGenericError: 'Unable to send reply/outbound',
    genericErrorMsg: 'Error. Unable to complete search.',
    startAnotherInteraction: 'Start Another Interaction',
    inboundVoice: 'Inbound Voice',
    outboundVoice: 'Outbound Voice',
    digital: 'Digital',
    wemDirectedToNewWindow:
      'You have been directed to WEM on a separate window. If you do not see a separate window, please check either your pop-up blocker or click',
    searchDirectoryPlaceHolder:
      'Search Directory or press Enter for all results',
    download: 'Baixar',
    downloadInfo: 'Download started successfully',
    downloadError: 'Unable to download/preview attachment',
    removeLink: 'Remove link',
    addLink: 'Add link',
    exampleEmail: 'http://www.example.com',
    transferDigitalSkill: 'Digital skill transferred successfully',
    transferDigitalContact: 'Digital contact transferred successfully',
    queueCounter: 'Contador de Filas',
    here: 'here',
    new: 'Nova',
    add: 'Adicionar',
    view: 'Vista',
    escalated: 'Escalated',
    pending: 'Pendente',
    consultMessage:
      'You are already in call with agent. Cannot add another call.',
    backgroundColor: 'Highlight Color',
    textColor: 'Text Color',
    resetColor: 'Reset Color',
    resetHighlight: 'Reset Highlight',
    notes: 'Anotações',
    enterNotes: 'Inserir notas',
    disposition: 'Disposição',
    status: 'Estado',
    tags: 'Tags',
    networkFailure: 'Network error. Attempting to reconnect.',
    restart: 'Restart',
    dispositionSaved: 'Disposition saved Successfully.',
    unableToSaveDisposition: 'Unable to save Disposition.',
    line: 'Line',
    wechat: 'WeChat',
    microsoftteams: 'MS Teams',
    slack: 'Slack',
    viber: 'Viber',
    applebusinesschat: 'Apple Business Chat',
    time: 'Time',
    phone: 'Phone',
    addCommitments: 'Add Commitment',
    customer: 'Customer',
    firstName: 'First Name',
    lastName: 'Last Name',
    contactInformation: 'Contact Information',
    commitment: 'Commitment',
    other: 'Other',
    like: 'Como',
    selected: 'Selecionado',
    reactionError: 'Unable to send selected reaction',
    messageDeleted: 'Deleted',
    help: 'Ajuda',
    hideUnhideError: 'Unable to hide/unhide message',
    Starttypingtofindthing: 'Comece a digitar para encontrar algo',
    ccfActivityId: 'ID:',
    ccfActivityPriority: 'Priority:',
    ccfActivityAssignedTo: 'Assigned To:',
    ccfActivitySearch: 'Search',
    deleteError: 'Unable to delete message',
    messageDeleteSuccess: 'Message Deleted Successfully',
    mobile: 'Mobile',
    externalDirectories: 'External Directories',
    comments: 'Comentários',
    replies: 'Respostas',
    goBack: 'Voltar',
    addNotes: 'Adicionar notas',
    skill: 'Habilidade',
    agent: 'Agent (Me)',
    share: 'Compartilhar',
    retweet: 'Retuitar',
    contactCardMerged: 'Contact Card Merged',
    searchContacts: 'Search for Contacts',
    voicemail: 'Correio de voz',
    inboundCall: 'Chamada de entrada',
    fnameErrorMessage: 'Please enter first name',
    lnameErrorMessage: 'Please enter last name',
    dateTimeErrorMessage: 'Please select a future date/time',
    phoneErrorMessage: 'Please enter a valid number',
    editCommitment: 'Edit Commitment',
    timeZone: 'Fuso horário',
    editStatus: 'Editar status',
    networkstatus: 'Status da rede',
    remove: 'Remove',
    keep: 'Keep',
    removeCommitmentConfirmationTitle: 'Remove Commitment',
    removeCommitmentConfirmationMsg:
      'Are you sure you want to remove this commitment?',
    screenPopFocusOnWindow: 'To open this page in another browser/tab, click',
    hidePublicMessageSuccess: 'Message Hidden Successfully',
    unhidePublicMessageSuccess: 'Message is no longer hidden',
    hideMessageError: 'Unable to hide message',
    unHideMessageError: 'Unable to unhide message',
    edited: 'edited',
    callback: 'Callback',
    rewind: 'Rewind',
    replay: 'Replay',
    viewMoreMessages: 'View more messages',
    noteDeleted: 'Note deleted',
    reply: 'Resposta',
    helperTextMessageForNotes: 'Notes are required',
    deleted: 'Deleted',
    pause: 'Pause',
    pendingApproval: 'Pending Approval',
    editApprovalRequest: 'Edit Approval Request',
    softphoneHelpTitle: 'Install Softphone Extension',
    softphoneHelpDescriptionMain:
      'For enhanced call experience, it is recommended to install the CXone Softphone Extension from the Chrome Web Store.',
    softphoneHelpDescriptionSub: 'Click here for details',
    softphoneDonotRemind: 'Do Not Remind Me',
    softphoneRemindMe: 'Remind Me Later',
    sendMessage: 'Send Message',
    shared: 'Shared',
    retweeted: 'Re-Tweeted',
    customWorkspace: 'Espaço de trabalho personalizado',
    Reschedule: 'Reschedule',
    Proceed: 'Proceed',
    rescheduleCommitment: 'Reschedule Commitment',
    interactionRouting: 'Roteamento de interação',
    calls: 'Calls',
    caseCustomFieldSaved: 'Your Changes has been saved.',
    caseCustomFieldNotSaved: 'Changes did not save. Try Again',
    googleBusinessMessage: 'Google Business Message',
    approvalDenied: 'Message Denied',
    refuseApprovalError: 'unable to deny approval',
    ApproveDraftMessageError: 'Unable to approve the draft message',
    updateDraftMessageError: 'Unable to update the draft message',
    standardAddressBookHeading: 'Standard Address Book',
    unknown: 'Unknown',
    fontSize: 'Font Size',
    fontFamily: 'Font Family',
    black: 'Black',
    pickledBluewood: 'Pickled bluewood',
    osloGray: 'Oslo gray',
    changeStatusTo: 'Alterar status para',
    change: 'Alarter',
    location: 'Localização',
    selectedinteractionswillhavetheirstatus:
      'As interações selecionadas terão seu status alterado para',
    selectedinteractionstatushasbeenchangeto:
      'O status da interação selecionada foi alterado para',
    customizedreplymessage:
      'Mensagem de resposta personalizada foi enviada para as interações selecionadas',
    statusChangeToastMsg: 'A interação selecionada foi atribuída a',
    importToasterMsg: 'A interação selecionada foi exportada no formato CSV',
    interactionStatusChangeNote1:
      'As interações selecionadas terão esta mensagem de resposta enviada a elas. Você será atribuído a qualquer interação que não tenha sido atribuída ',
    interactionStatusChangeNote2:
      'E uma nova interação será criada para qualquer interação que não tenha sido atribuída',
    pewter: 'Pewter',
    zumthor: 'Zumthor',
    athensGray: 'Athens gray',
    matisse: 'Matisse',
    vividViolet: 'Vivid violet',
    goldenGateBridge: 'Golden gate bridge',
    zest: 'Zest',
    elfGreen: 'Elf green',
    bleuDeFrance: 'Bleu de France',
    richLilac: 'Rich lilac',
    cgRed: 'Cg red',
    jonquil: 'Jonquil',
    ufoGreen: 'Ufo green',
    coralCandy: 'Coral candy',
    tropicalBlue: 'Tropical blue',
    frenchLilac: 'French lilac',
    astra: 'Astra',
    aeroBlue: 'Aero blue',
    txtExsmall: 'Extra Small',
    txtSmall: 'Small',
    txtRegular: 'Regular',
    txtLarge: 'Large',
    txtExlarge: 'Extra Large',
    emailValidationMessage: 'Enter valid Email',
    incomingInteraction: 'Incoming Interaction',
    liveInteractionHasEnded: 'Live Interaction has ended',
    newInteractionResponse: 'New Interaction response',
    contactID: 'Contact ID',
    ani: 'ANI',
    returnToAgentView: 'Return to Agent View',
    openInNewTab: 'Open in New Tab',
    viewingInBrowserMessage: 'You are viewing this page in your web browser',
    clickHere: 'Click Here',
    viewInBrowser: 'to view in your Browser',
    viewInAgentApp: 'to view in the agent App',
    whatsappNotificationOnDraftScreen:
      'WhatsApp communication is limited to Quick Replies until the customer responds',
    deleteDraftMessageError: 'Unable to delete the draft message',
    voiceLimit:
      'The no of phone and voicemail contacts that can be simultaneously handled',
    digitalLimit:
      'The no of digital contacts that can be simultaneously handled',
    initiateWhatsappContactError: 'Unable to initiate Whatsapp contact',
    sendMessageSuccess: 'Message sent successfully',
    msgTemplates: 'Message Templates',
    contact: 'contact',
    channelDetails: 'Channel Details',
    none: 'Nenhum',
    noContactInfo: 'No Contact Info',
    ring1: 'Anel 1',
    ring2: 'Anel 2',
    ring3: 'Anel 3',
    yesterday: 'Ontem',
    custom: 'Costume',
    TwentyFourHourTime: '24 horas',
    panelOpenInBrowser: 'Painel Abrir no navegador',
    last24hours: 'Últimas 24 horas',
    last7days: 'Últimos 7 dias',
    last30days: 'Últimos 30 dias',
    segments: 'Segments',
    shift: 'TURNO',
    play: 'brincar',
    public: 'Público',
    reqApprovalMessageError: 'Unable to request for message approval: {x}',
    requestApproval: 'Solicitar aprovação',
    whatsAppOutboundAgentNotification:
      'Your message has been sent. You will be able to reply once the client has responded.',
    companyInformation: 'Company Information',
    approve: 'Approve',
    deny: 'Deny',
    recentlyUsed: 'Usado recentemente',
    hasalreadybeenadded: 'já foi adicionado.',
    isnotavalidemailaddress: 'não é um endereço de e-mail válido.',
    textDirectionltr: 'Left to Right Text Direction',
    textDirectionrtl: 'Right to Left Text Direction',
    information: 'Informação',
    unhandledExceptionError:
      'An unexpected error has occured. Please reload the application.',
    reloadAppBtn: 'Reload',
    disableTransferMessage:
      'Transfer is not allowed at this point in time. Please inititate a new conversation.',
    noOBSkillAssigned: 'No outbound skills are assigned to the agent',
    addElevation: 'Adicionar elevação',
    qReplySent: 'Quick Reply Sent',
    waitingOnHoldX: 'Waiting on Hold',
    allCodes: 'Todos os códigos',
    reports: 'Relatórios',
    customIzeToolBar: 'Personalizar a barra de ferramentas',
    addCommitment: 'Adicionar um compromisso',
    inQueue: 'NA FILA',
    agentStates: 'ESTADO DO AGENTE',
    noAssignedSkills: 'Sem Habilidades Atribuídas',
    noSkillsAssigned: 'Nenhuma habilidade atribuída',
    contactsInQueue: 'CONTATOS NA FILA',
    agentSkills: 'Habilidades do agente',
    AssignedSkills: 'Habilidades atribuídas',
    workitem: 'Item de trabalho',
    ssoLogin: 'Entrar usando SSO',
    lastUpdated: 'Ultima atualização',
    customize: 'Customize',
    greeting: 'Oi',
    copilotIntroduction:
      'O Copilot fornece insights e respostas que potencializam experiências excepcionais.',
    howCanIHelp: 'Como posso ajudar?',
    intents: 'Intents',
    enterIntents: 'Enter Intents',
    enterOutcomes: 'Enter Outcomes',
    enterActions: 'Enter Actions',
    enterEntities: 'Enter Entities',
    actions: 'Actions',
    entities: 'Entities',
    InboundVoice: 'Voz de entrada',
    InboundVideoCall: 'Chamada de vídeo de entrada',
    InboundVoiceMail: 'Correio de voz de entrada',
    ZenDesk: 'ZenDesk',
    CRM: 'De acordo com o',
    X: 'X',
    coPilot: 'Copilot',
    applications: 'Aplicativos',
    admin: 'Admin',
    supervisor: 'Supervisor',
    GENERAL: 'GERAL',
    OMNICHANNELROUTING: 'ROTEAMENTO OMNICHANNEL',
    ACD: 'ACD',
    CXoneAgent: 'CXone Agente',
    Patron: 'Patrono',
    DATAANALYTICS: 'DADOS E ANALÍTICA',
    Analytics: 'ANALÍTICA',
    Reporting: 'Relatórios',
    AUTOMATION: 'AUTOMAÇÃO',
    WFI: 'WFI',
    Meeting: 'Reunião',
    Lunch: 'Almoço',
    Client: 'Cliente',
    PerformanceReview: 'Revisão de desempenho',
    DataEntry: 'Entrada de dados',
    WorkingOB: 'Trabalhando-OB',
    Research: 'Pesquisa',
    Coaching: 'Treinamento',
    Offsite: 'Fora do local',
    Training: 'Treinamento',
    HR: 'RH',
    Break: 'quebrar',
    sort: 'Ordenar',
    notificationBadge: 'Notificações',
    refresh: 'Atualizar',
    expand: 'Expandir',
    collapse: 'Colapso',
    sortBy: 'Ordenar por',
    createdDate: 'Data de criação',
    lastVisited: 'Última visita',
    privateChat: 'Bate-papo Privado',
    sendTranscript: 'Enviar Transcrição',
    openInNewBrowserWindow: 'Abrir em uma nova janela do navegador',
    inviteToCobrowsing: 'Convidar para co-browsing',
    chatWith: 'Converse com',
    note: 'Nota',
    coBrowse: 'CO-PROCURAR',
    coBrowseWithAgent:
      'Preparamos uma sessão de co-navegação para você. Clique abaixo para co-navegar com nosso agente.',
    joinAgent: 'Agente de Ingresso',
    coBrwosingSessionEnd: 'Sua sessão de co-navegação terminou em',
    coBrowseSessionInProgress: 'Sessão de co-navegação em andamento',
    endSession: 'Encerrar sessão',
    selectItem: 'Selecionar item',
    travelReservation: 'Reservas de viagens',
    yes: 'Sim',
    no: 'Não',
    autosummaryCompleted: 'Resumo automático concluído',
    generatingSummary: 'Gerando resumo',
    summaryGenerationMsg: 'Você poderá editar notas assim que for gerado',
    markAllAs: 'Marcar tudo como',
    insertResponse: 'Inserir resposta',
    sendResponse: 'Enviar resposta',
    dislikeResponse: 'Dislike Response',
    likeResponse: 'Like Response',
    interactionSearch: 'Pesquisa de interação',
    conversationTopics: 'Tópicos de Conversa',
    copilotAlert: 'Alerta do Copiloto',
    agentPraise: 'Elogio ao Agente',
    copilotInsight: 'Visão do Copiloto',
    taskAssist: 'Assistente de Tarefas',
    completedByTaskAssist: 'Concluído por Assistente de Tarefas',
    searchTopic: 'Pesquisar Tópico',
    removeTopic: 'Remover Tópico',
    newSkills: 'Novas habilidades',
    contactSettings: 'CONFIGURAÇÕES DE CONTATO',
    acdSkills: 'Habilidades ACD',
    Campaigns: 'Campanhas',
    Dispositions: 'Disposições',
    PointsofContact: 'Pontos de contato',
    EmailDomains: 'Domínios de e-mail',
    SMSBranding: 'Marca SMS',
    SMSRegistration: 'Registro de SMS',
    HoursofOperation: 'Horário de funcionamento',
    ChatProfile: 'Perfil de bate-papo',
    Tags: 'Tags',
    OUTBOUND: 'SAÍDA',
    SkillControl: 'Controle de habilidade',
    SkillChannelSettings: 'Configurações do canal de habilidades',
    MessageTemplates: 'Modelos de Mensagem',
    LISTS: 'LISTAS',
    Calling: 'Vocação',
    CallSuppression: 'Supressão de chamadas',
    DoNotCall: 'Não ligue',
    CustomDataDefinitions: 'Definições de dados personalizadas',
    ProcessQueue: 'Fila de Processo',
    ACDSETTINGS: 'CONFIGURAÇÕES ACD',
    UnavailableCodes: 'Códigos Indisponíveis',
    Stations: 'Estações',
    AddressBooks: 'Agendas de endereços',
    StationProfiles: 'Perfis de Estação',
    QuickReplies: 'Respostas rápidas',
    AgentPatterns: 'Padrões de Agente',
    Locations: 'Localizações',
    ACDCONFIGURATION: 'CONFIGURAÇÃO ACD',
    BusinessUnits: 'Unidades de Negócios',
    DatabaseConnectors: 'Conectores de banco de dados',
    SUPPORT: 'APOIO',
    AgentMessaging: 'Mensagens de Agente',
    AgentIssues: 'Problemas de Agente',
    BrowseACDFiles: 'Procurar arquivos ACD',
    DFO: 'DFO',
    SLA: 'SLA',
    hoursofOperation: 'Horário de funcionamento',
    CustomFields: 'Campos personalizados',
    Routing: 'Roteamento',
    RoutingQueues: 'Filas de Roteamento:',
    BringYourOwnChannel: 'Traga seu próprio canal',
    Forms: 'Formulários',
    SatisfactionSurveys: 'Pesquisas de satisfação',
    Typeareplyhere: 'Digite uma resposta aqui',
    changePassword: 'Alterar senha',
    supportDownloads: 'Suporte e Downloads',
    contactus: 'Contate-Nos',
    overview: 'Visão geral',
    details: 'Detalhes',
    interactions: 'Interações',
    externalData: 'Dados Externos',
    tickets: 'Bilhetes',
    FULLNAME: 'NOME COMPLETO',
    CUSTOMERSINCE: 'CLIENTE DESDE',
    ACCOUNTNUMBER: 'NÚMERO DA CONTA',
    SALUTATION: 'SAUDAÇÃO',
    TITLE: 'TÍTULO',
    BALANCE: 'BALANÇO',
    NEXTPAYMENT: 'PRÓXIMO PAGAMENTO',
    ACCOUNT: 'CONTA#',
    ACCOUNTTYPE: 'NÍVEL DE CONTA',
    ACCOUNTLEVEL: 'NÍVEL DE CONTA',
    DATEOFBIRTH: 'DATA DE NASCIMENTO',
    ADDRESS: 'ENDEREÇO',
    PREFERREDCONTACTMETHOD: 'MÉTODO DE CONTATO PREFERIDO',
    LATESTINTERACTIONSUMMARY: 'ÚLTIMO RESUMO DE INTERAÇÕES',
    LATESTNOTES: 'ÚLTIMAS NOTAS',
    PRIMARYRESIDENCE: 'RESIDÊNCIA PRIMÁRIA',
    BILLINGADDRESS: 'ENDEREÇO DE FATURAMENTO',
    OTHERS: 'OUTROS',
    GUARANTOR: 'GARANTIDOR',
    GUARANTORLASTNAME: 'SOBRENOME DO GARANTIDOR',
    GUARANTORFIRSTNAME: 'NOME PRÓPRIO DO GARANTIDOR',
    GuarantorSameAsContact: 'Garantidor igual ao contato',
    FIRSTNAME: 'NOME PRÓPRIO',
    LASTNAME: 'SOBRENOME',
    DEPARTMENT: 'DEPARTAMENTO',
    CONTACTTOSPEAK: 'CONTATO PARA FALAR',
    CONTACTGROUP: 'GRUPO DE CONTATO',
    AGENT: 'AGENTE',
    AGENTTEAM: 'EQUIPE DE AGENTES',
    AddAddress: 'Adicionar endereço +',
    BillingAddresssameasPrimaryAddress:
      'Endereço de cobrança igual ao endereço principal',
    ADDRESS1: 'ENDEREÇO 1',
    ADDRESS2: 'ENDEREÇO 2',
    CITY: 'CIDADE',
    STATE: 'ESTADO',
    ZIPCODE: 'CÓDIGO POSTAL',
    COUNTRY: 'PAÍS',
    Addressdetailssavedsuccessfully: 'Detalhes do endereço salvos com sucesso',
    Generaldetailssavedsuccessfully: 'Detalhes gerais salvos com sucesso',
    Othersdetailssavedsuccessfully: 'Outros detalhes salvos com sucesso',
    cases: 'Casos',
    threads: 'Threads',
    customers: 'Clientes',
    filters: 'Filtros',
    columns: 'Colunas',
    searchcontent: 'Pesquisar conteúdo',
    type: 'Tipo',
    customerName: 'Nome do cliente',
    agenda: 'Agenda',
    noSchedule: 'Sem agenda (0)',
    outofoffice: 'Fora do escritório',
    onCall: 'Em chamada',
    noData: 'Sem dados (0)',
    addActivity: 'Adicionar atividade',
    or: 'ou',
    productivity: 'Produtividade',
    performance: 'Desempenho',
    dailerPending: 'Dialer Pendente',
    afterCallWork: 'Trabalho pós-chamada',
    agentState: 'Estado do agente',
    rowsPerPage: 'Linhas por página',
    SelectDateRange: 'Selecione o intervalo de datas',
    Personal: 'Pessoal',
    team: 'Equipe',
    callType: 'Tipo de chamada',
    you: 'Você',
    sales: 'Vendas',
    customerSupport: 'Suporte ao cliente',
    followUp: 'Acompan',
    escalations: 'Escalas',
    VoiceMail_1: 'Correio de voz_1',
    VoiceMail_2: 'Correio de voz_2',
    customerIsUnhappy: 'O cliente está infeliz',
    cannotFindLuggage: 'Não consigo encontrar minha bagagem',
    wantsToChangeFlight: 'Quer mudar o voo',
    viewWebinars: 'Ver webinars',
    CustomerSentimentisNeutral: 'O sentimento do cliente é neutro',
    CustomerSentimentisPositive: 'O sentimento do cliente é positivo',
    CustomerSentimentisNegative: 'O sentimento do cliente é negativo',
    CopilotAlert: 'Alerta do Copiloto',
    CopilotInsight: 'Visão do Copiloto',
    AgentPraise: 'Elogio ao Agente',
    showSimulatorButton: 'Mostrar botão do simulador',
    openCalender: 'Abrir Calendário',
    showCustomWorkSpace: 'Mostrar espaço de trabalho personalizado',
    openCRM: 'Abrir CRM',
    showPartnerAccessButton: 'Mostrar botão de acesso ao parceiro',
    inboxAssigneeUser: 'caixa de entrada AssigneeUser',
    onwerAssigneedUser: 'proprietário AssigneeUser',
    voiceDirection: 'Direção da voz',
    serviceBot: 'Bot de serviço',
    date: 'Data',
    Agent: 'Agente',
    Transcription: 'Transcrição',
    endOfTranscription: 'Fim da transcrição',
    campaign: 'Campanha',
    start: 'Iniciar',
    autoSummary: 'Resumo automático',
    selectDateRange: 'Selecione o intervalo de datas',
    customDateRange: 'Intervalo de datas personalizado',
    lastWeek: 'Última semana (7 dias)',
    lastMonth: 'Último mês (30 dias)',
    last90Days: 'Últimos 90 dias',
    startOfConversation: 'Início da conversa',

    // consumer app space notes tab

    add_note: 'Adicionar nota',
    note_title: 'Título',
    // consumer app space external data tab
    loyalty_info: 'Informações de fidelização',
    gold_elite: 'ELITE OURO #132192693',
    recent_trips: 'VIAGENS RECENTES',
    upcoming_trips: 'PRÓXIMAS VIAGENS',
    marriott_dallas: 'Marriot Dallas',
    courtyard_miami: 'Pátio Miami',
    marriott_hawaii: 'Marriott Havai',
    marriott_florida: 'Marriott Flórida',
    points: '75.860 PONTOS',
    confirmation: 'Confirmação',
    sep_date: '1 a 5 de setembro de 2023',
    aug_date: '10 a 15 de agosto de 2023',
    jul_date: '13 a 16 de julho de 2023',
    case: 'Caso',
    current_record: 'REGISTO ATUAL',
    related_record: 'REGISTO RELACIONADO',
    servicenow_current_record_details:
      'O cliente ligou sobre a sua reserva de hotel para saber se tinha direito a um upgrade gratuito.',
    servicenow_related_record_details:
      'O cliente ligou sobre a reserva do hotel para adicionar estacionamento com manobrista.',
    low_status: '4 - Baixo',
    priority: 'Prioridade',
    onboarding_request_service: 'Integração - Solicitar Serviço',
    airline_customer_service: 'Atendimento ao Cliente da Companhia Aérea',

    high: 'Alto',
    medium: 'Médio',
    low: 'Baixo',
    // Adaptive cards translations
    adp_journeySummary: 'Resumo da Jornada',
    adp_internalUseOnly: 'Uso Interno Apenas',
    adp_webLinks: 'Links da Web',
    adp_images: 'Imagens',
    adp_processSteps: 'Etapas do Processo',
    adp_insertArticle: 'Inserir Artigo',
    adp_insertLink: 'Inserir Link',
    adp_insertImage: 'Inserir Imagem',
    adp_insertSteps: 'Inserir Etapas',
    adp_insertStep: 'Inserir Etapa',
    adp_sendArticle: 'Enviar Artigo',
    adp_sendLink: 'Enviar Link',
    adp_sendImage: 'Enviar Imagem',
    adp_sendSteps: 'Enviar Etapas',
    adp_sendStep: 'Enviar Etapa',
    adp_openLink: 'Abrir Link',
    adp_expandImage: 'Expandir Imagem',
    adp_positiveSentiment: 'Sentimento do Cliente é Positivo',
    adp_negativeSentiment: 'Sentimento do Cliente é Negativo',
    adp_neutralPositiveSentiment: 'Sentimento do Cliente é Neutro',
    adp_neutralNegativeSentiment: 'Sentimento do Cliente é NeutroNegativo',
    adp_transferSummary: 'Resumo da Transferência',
    adp_generateEmailResponse: 'Gerar Resposta por Email',
    adp_replyIsGenerating: 'Resposta está sendo gerada',
    adp_generate: 'Gerar',
    adp_replyGenerated: 'Resposta Gerada',
    adp_noAutomaticSuggestionFound: 'Nenhuma sugestão automática encontrada',
    adp_emailGeneratorIsCurrentlyDown: 'Gerador de Email está fora do ar',
    adp_possibleComplianceRisk: 'Possível Risco de Conformidade',
    adp_salesOffers: 'Ofertas de Vendas',
    adp_features: 'Características',
    adp_pricing: 'Preços',
    adp_justification: 'Justificativa',
    adp_last: 'ÚLTIMO',
    adp_interactions: 'INTERAÇÕES',
    adp_closed: 'FECHADO',
    adp_open: 'ABERTO',
    adp_rateYourCopilotExperience: 'Avalie sua experiência com o Copilot.',
    adp_helpUsToMakeYourExperienceBetterByLettingUsKnowWhichCardsYouFoundHelpful:
      'Ajude-nos a melhorar sua experiência, informando quais cartões você achou úteis.',
    adp_searchTopic: 'Pesquisar Tópico',
    adp_removeTopic: 'Remover Tópico',
    adp_insertCompliance: 'Inserir Conformidade',
    adp_sendCompliance: 'Enviar Conformidade',
    adp_likeArticle: 'Curtir Artigo',
    adp_likedArticle: 'Artigo Curtido',
    adp_dislikeArticle: 'Não Curtir Artigo',
    adp_dislikedArticle: 'Artigo Não Curtido',
    adp_insertSalesOffers: 'Inserir Ofertas de Vendas',
    adp_sendSalesOffers: 'Enviar Ofertas de Vendas',
    adp_autoRun: 'Execução Automática',
    adp_Open: 'Abrir',
    adp_Close: 'Fechar',
    adp_sendQuestion: 'Enviar Pergunta',
    adp_submit: 'Enviar',
    adp_shareWithClient: 'Compartilhar com o Cliente',
    adp_save: 'Salvar',
    autopilotTransferSummary: 'Resumo da Transferência do Autopilot',
    agentTransferSummary: 'Resumo da Transferência do Agente',

    copilotEmailGenerationPlaceholderText: 'O Copilot está gerando uma resposta para você.',
    copilotEmailUpdatingPlaceholderText: 'O Copilot está atualizando a resposta para você.',

    // OneBank
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onebank_how_can_i_help_you_today:
      'Hi, my name is Julie.  Thank you for reaching out to OneBank.  How can I help you today?',
    hi_there_i_have_a_few_things_i_wanted_to_find_out_about_today_i_hope_you_can_help_me:
      'Hi there, I have a few things I wanted to find out about today, I hope you can help me',
    thank_you_i_would_like_to_explore_setting_up_a_trust_can_you_tell_me_about_some_of_the_benefits_and_drawbacks_i_should_consider:
      'Thank you.  I would like to explore setting up a trust. Can you tell me about some of the benefits and drawbacks I should consider?',
    are_there_different_types_of_trusts: 'Are there different types of trusts?',
    thank_you_it_sounds_like_i_need_to_do_some_more_research:
      'Thank you. It sounds like I need to do some more research',
    the_next_thing_id_like_to_discuss_is_helping_pay_for_my_grandsons_education_ive_been_considering_a_529_plan_can_you_tell_me_about_529_plans:
      "The next thing I'd like to discuss is helping pay for my grandson's education.  I've been considering a 529 plan.  Can you tell me about 529 plans?",
    how_are_529_plans_typically_funded: 'How are 529 plans typically funded?',
    i_think_id_want_to_fund_it_through_a_payroll_deduction_how_would_i_set_that_up:
      "I think I'd want to fund it through a payroll deduction.  How would I set that up?",
    i_can_give_you_an_overview_of_the_process_but_you_would_have_to_set_up_the_529_account_before_you_can_start_funding_it:
      'I can give you an overview of the process but you would have to set up the 529 account before you can start funding it.',
    yes_thank_you_for_that_information: 'Yes, thank you for that information.',
    ok_the_last_thing_i_want_to_talk_about_is_mortgages_id_like_to_help_my_granddaughter_buy_her_first_home_but_i_want_her_to_educate_herself_and_select_the_right_type_of_mortgage_do_you_have_any_tools_or_information_for_firsttime_homebuyers:
      "Ok.  The last thing I want to talk about is mortgages.  I'd like to help my grand-daughter buy her first home, but I want her to educate herself and select the right type of mortgage.  Do you have any tools or information for first-time homebuyers?",
    that_is_great_thank_you: 'That is great.  Thank you!',
    is_there_is_anything_else_i_can_assist_you_with_today:
      'Is there is anything else I can assist you with today?',
    no_that_would_be_it_you_have_been_great_thank_you_so_much_for_your_help:
      'No that would be it, you have been great!  Thank you so much for your help!',
    you_are_very_welcome_thank_you_for_contacting_onebank_and_for_your_business:
      'You are very welcome, thank you for contacting OneBank and for your business!',

    // OneBank_mortgage
    hello_peter_this_is_emily_thank_you_for_reaching_out_to_onebank_i_see_you_indicated_your_interest_in_mortgages_what_can_i_help_you_with_today:
      'Hello Peter, this is Emily. Thank you for reaching out to OneBank. I see you indicated your interest in mortgages. What can I help you with today?',
    hey_yes_this_is_my_first_home_so_im_trying_to_learn_the_basics:
      "Hey - yes this is my first home so I'm trying to learn the basics",
    are_there_different_kinds_of_mortgages:
      'Are there different kinds of mortgages?',
    whats_the_difference_between_fixed_and_adjustable_mortgages:
      "What's the difference between fixed and adjustable mortgages?",
    thanks: 'Thanks',
    what_is_the_process_to_get_preapproved:
      'What is the process to get pre-approved?',
    i_can_help_you_begin_the_preapproval_process_now_if_youd_like:
      "I can help you begin the pre-approval process now if you'd like",
    thx_i_just_wanted_a_little_info_today:
      'Thx I just wanted a little info today',
    ill_digest_and_reach_back_out_in_a_few_days:
      "I'll digest and reach back out in a few days",
    i_can_also_schedule_you_on_the_day_and_time_of_your_choosing:
      'I can also schedule you on the day and time of your choosing?',
    yeah_that_sounds_good: 'Yeah that sounds good',
    your_appointment_is_confirmed_do_you_have_any_other_questions_i_can_address_today:
      'Your appointment is confirmed. Do you have any other questions I can address today?',
    im_all_set_you_have_been_super_helpful_thank_you:
      "I'm all set. You have been super helpful! Thank you",

    // Insurance
    hi_my_name_is_oscar_thank_you_for_reaching_out_to_oneinsurance_how_can_i_help_you_today:
      'Hi, my name is Oscar.  Thank you for reaching out to OneInsurance.  How can I help you today?',
    hi_there_im_shopping_around_for_insurance_and_i_have_a_few_questions_im_hoping_you_can_help_me_with:
      'Hi there, I’m shopping around for insurance and I have a few questions I’m hoping you can help me with.',
    thank_you_lets_start_with_the_home_do_your_home_owners_policies_include_loss_of_use_coverage:
      "Thank you.  Let’s start with the home.  Do your home owner's policies include loss of use coverage?",
    does_home_insurance_cover_flooding: 'Does home insurance cover flooding?',
    what_does_flood_insurance_cover: 'What does flood insurance cover?',
    ok_thanks_now_lets_move_on_to_auto_do_your_auto_policies_include_accident_forgiveness:
      'Ok, thanks, now let’s move on to Auto.  Do your auto policies include accident forgiveness?',
    can_you_talk_me_through_the_claims_process:
      'Can you talk me through the claims process?',
    thank_you_that_was_helpful_but_what_if_my_repairs_cost_more_than_your_estimate:
      'Thank you, that was helpful.   But what if my repairs cost more than your estimate?',
    ok_thank_you_im_starting_to_explore_getting_disability_income_insurance_i_live_in_a_single_income_household_how_does_disability_income_insurance_work:
      'Ok, thank you. I’m starting to explore getting Disability Income Insurance. I live in a single income household. How does Disability Income Insurance work?',
    what_does_disability_income_insurance_cost:
      'What does disability income insurance cost?',
    how_would_i_go_about_getting_a_quote_from_you:
      'How would I go about getting a quote from you?',
    i_could_schedule_a_time_for_an_insurance_agent_to_call_you_to_gather_this_information_and_provide_you_with_a_quote:
      'I could schedule a time for an insurance agent to call you to gather this information and provide you with a quote?',
    that_would_be_great_thank_you: 'That would be great, thank you!',
    is_there_anything_else_i_can_help_you_with_today:
      'Is there anything else I can help you with today?',
    you_are_very_welcome_thank_you_for_contacting_onetelecom_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTelecom and have a great day!',

    // OneUniversity
    hi_there_my_name_is_anthony_thank_you_for_reaching_out_to_one_education_university_how_can_i_help_you_today:
      'Hi there, my name is Anthony.  Thank you for reaching out to One Education University.  How can I help you today?',
    yes_im_interested_in_your_bs_in_criminal_justice_program_will_this_program_help_me_prepare_for_licensure_in_the_state_of_minnesota:
      "Yes.  I'm interested in your BS in Criminal Justice program.  Will this program help me prepare for licensure in the state of Minnesota?",
    ok_i_guess_thats_good_to_know_ill_have_to_take_that_into_consideration:
      "Ok, I guess that's good to know.  I'll have to take that into consideration.",
    can_i_transfer_credits_from_another_institution:
      'Can I transfer credits from another institution?',
    whats_the_maximum_number_of_credits_i_can_transfer:
      "What's the maximum number of credits I can transfer?",
    what_are_the_tuition_costs_for_the_bs_in_criminal_justice_program:
      'What are the tuition costs for the BS in criminal justice program?',
    can_you_tell_me_about_your_application_process:
      'Can you tell me about your application process?',
    great_thank_you_for_all_the_information_i_have_a_lot_to_think_about:
      'Great! Thank you for all the information.  I have a lot to think about',
    would_you_like_to_speak_with_an_admissions_counselor_they_can_answer_any_further_questions_you_might_have:
      'Would you like to speak with an admissions counselor? They can answer any further questions you might have.',
    that_would_be_great: 'That would be great!',
    awesome_thank_you: 'Awesome! Thank you!',
    no_thats_it_thank_you_again_for_all_your_help_today:
      "No, that's it.  Thank you again for all your help today!",

    // Telecom
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onetelecom_how_can_i_help_you_today:
      'Hi, my name is Julie. Thank you for reaching out to OneTelecom. How can I help you today?',
    hi_there_i_have_a_few_questions_today_i_hope_you_can_help_me:
      'Hi there, I have a few questions today, I hope you can help me',
    thank_you_i_just_received_my_first_bill_and_it_was_higher_than_i_expected_and_im_not_sure_why:
      "Thank you. I just received my first bill and it was higher than I expected and I'm not sure why.",
    ok_that_makes_sense_thank_you: 'Ok, that makes sense. Thank you.',
    can_you_help_me_sign_up_for_autopay: 'Can you help me sign up for AutoPay?',
    yes_thank_you_so_much: 'Yes, thank you so much!',
    im_going_to_start_working_from_home_and_i_wonder_if_my_internet_is_fast_enough:
      "I'm going to start working from home and I wonder if my internet is fast enough.",
    how_can_i_do_a_speed_test_to_see_what_speed_im_actually_getting:
      "How can I do a speed test to see what speed I'm actually getting?",
    ok_give_me_a_minute_to_do_that_please:
      'Ok, give me a minute to do that please.',
    im_getting_closer_to_40_mbps_so_i_guess_im_all_set_with_my_internet:
      "I'm getting closer to 40 Mbps, so I guess I'm all set with my internet.",
    im_looking_to_add_tv_service_through_you_can_you_tell_me_about_your_plans:
      "I'm looking to add TV service through you. Can you tell me about your plans?",
    i_think_id_like_to_go_ahead_and_sign_up_for_the_popular_package_can_you_help_me_with_that:
      "I think I'd like to go ahead and sign up for the popular package. Can you help me with that?",
    absolutely_lets_get_you_signed_up: "Absolutely! Let's get you signed up!",
    is_there_anything_else_i_can_assist_you_with_today:
      'Is there anything else I can assist you with today?',
    you_are_very_welcome_thank_you_for_contacting_one_telecom_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTelecom and have a great day!',

    // OneHealth
    hi_my_name_is_julie_thank_you_for_reaching_out_to_onehealth_how_can_i_help_you_today:
      'Hi, my name is Julie.  Thank you for reaching out to oneHealth.  How can I help you today?',
    hi_i_just_signed_up_for_the_bronze_60_ppo_individual_plan_and_i_have_a_few_questions:
      'Hi.  I just signed up for the Bronze 60 PPO individual plan and I have a few questions.',
    thank_you_can_you_remind_me_what_the_monthly_cost_is_for_the_plan:
      'Thank you.  Can you remind me what the monthly cost is for the plan?',
    ok_thank_you_and_can_you_tell_me_about_the_broze_60_ppo_plan_details_and_coverage:
      'Ok, thank you.  And can you tell me about the Bronze 60 PPO plan details and coverage?',
    now_what_exactly_is_a_ppo: 'Now what exactly is a PPO?',
    do_i_need_a_referral_to_see_a_specialist_with_the_bronze_ppo_plan:
      'Do I need a referral to see a specialist with the Bronze PPO plan?',
    ok_thats_great_im_pregnant_and_im_going_to_be_having_a_baby_in_about_8_months_do_you_have_any_estimate_of_what_it_will_cost_me_out_of_pocket_to_have_a_baby_with_the_broze_60_ppo_plan:
      "Ok, that's great.  I'm pregnant and I'm going to be having a baby in about 8 months. Do you have any estimate of what it will cost me out of pocket to have a baby with the Bronze 60 PPO plan?",
    thats_very_helpful_thank_you_for_the_information:
      "That's very helpful, thank you for the information.",
    one_last_question_for_you_does_onehealth_offer_any_programs_to_help_members_live_healthy_lives:
      'One last question for you.  Does OneHealth offer any programs to help members live healthy lives?',
    thats_great_thank_you: "That's great.  Thank you!",
    i_guess_the_last_thing_i_need_help_with_is_finding_a_new_obgyn_and_making_an_appointment_can_you_help_me_with_that:
      'I guess the last thing I need help with is finding a new OBGYN and making an appointment.  Can you help me with that?',
    i_would_be_glad_to_help_you_with_that:
      'I would be glad to help you with that!',
    no_that_would_be_it_youve_been_great_thank_you_so_much_for_your_help:
      "No, that would be it, you've been great! Thank you so much for your help.",
    you_are_so_very_welcome_thank_you_for_reaching_out_to_onehealth_and_i_hope_you_have_a_great_appointment_with_your_new_obgyn:
      'You are so very welcome! Thank you for reaching out to OneHealth and I hope you have a great appointment with your new OBGYN.',

    // OneTravel
    hi_my_name_is_oscar_thank_you_for_reaching_out_to_onetravel_airlines_how_can_i_help_you_today:
      'Hi, my name is Oscar. Thank you for reaching out to OneTravel Airlines. How can I help you today?',
    hi_there_i_booked_my_first_flight_on_your_airline_a_few_days_ago_and_i_have_a_few_things_im_hoping_you_can_help_me_with:
      "Hi there, I booked my first flight on your airline a few days ago and I have a few things I'm hoping you can help me with.",
    thank_you_how_do_i_change_my_seat: 'Thank you. How do I change my seat?',
    i_had_surgery_on_my_left_leg_recently_and_im_still_moving_around_a_bit_slowly_can_i_add_special_assistance_to_my_reservation:
      "I had surgery on my left leg recently and I'm still moving around a bit slowly. Can I add special assistance to my reservation?",
    also_what_do_i_need_to_do_to_travel_with_my_service_animal:
      'Also, what do I need to do to travel with my service animal?',
    i_forgot_to_add_my_ktn_to_my_reservation_how_can_i_me_add_it:
      'I forgot to add my KTN to my reservation. How can I add it?',
    and_when_can_i_check_into_my_flight: 'And when can I check into my flight?',
    theres_a_possibility_that_i_may_need_to_change_my_travel_dates_how_would_i_change_my_flight:
      "There's a possibility that I may need to change my travel dates. How would I change my flight?",
    i_didnt_realize_you_had_an_app_ill_go_ahead_and_download_it:
      "I didn't realize you had an App. I'll go ahead and download it.",
    one_last_question_since_i_have_you_i_have_a_15_year_old_granddaughter_is_she_old_enough_to_take_a_domestic_flight_by_herself:
      'One last question since I have you. I have a 15 year old granddaughter. Is she old enough to take a domestic flight by herself?',
    thats_good_to_know_thank_you_so_much_for_your_help_today:
      "That's good to know. Thank you so much for your help today!",
    no_that_would_be_it_youve_have_been_great:
      "No that would be it, you've been great!",
    you_are_very_welcome_thank_you_for_contacting_onetravel_airlines_and_have_a_great_day:
      'You are very welcome, thank you for contacting OneTravel Airlines and have a great day!',

    // Public Sector
    hi_my_name_is_isabel_thank_you_for_reaching_out_to_state_i_see_that_you_would_like_some_help_completing_an_application_is_that_correct:
      'Hi, my name is Isabel. Thank you for reaching out to State. I see that you would like some help completing an application. Is that correct?',
    yes_please_i_would_appreciate_help_completing_my_application_for_the_child_care_payment_assistance_program:
      'Yes please, I would appreciate help completing my application for the Child Care Payment Assistance Program',
    of_course_thats_why_were_here_to_help_our_residents_when_they_need_it:
      "Of course, that's why we're here, to help our residents when they need it!",
    you_will_need_to_provide_your_personal_information_along_with_financial_employment_and_childcare_information_and_documentation_do_you_have_all_of_that_information_available:
      'You will need to provide your personal information along with financial, employment, and childcare information and documentation. Do you have all of that information available?',
    i_dont_i_didnt_realize_it_would_be_that_involved:
      "I don't. I didn't realize it would be that involved.",
    dont_worry_its_actually_quite_simple_it_just_sounds_like_a_lot_id_be_glad_to_send_you_a_paper_application_in_the_mail_or_schedule_a_time_to_call_you_back:
      "Don't worry, it's actually quite simple, it just sounds like a lot. I'd be glad to send you a paper application in the mail or schedule a time to call you back.",
    if_you_could_send_me_an_application_in_the_mail_that_would_be_great:
      'If you could send me an application in the mail, that would be great!',
    of_course_can_you_please_provide_your_mailing_address:
      'Of course! Can you please provide your mailing address?',
    sure_its_10300_jackson_street_apartment_1013:
      "Sure. It's 10300 Jackson Street, Apartment 1013.",
    ill_get_that_out_in_the_mail_to_you_today_is_there_anything_else_i_can_help_you_with_today:
      "I'll get that out in the mail to you today. Is there anything else I can help you with today?",
    yes_i_understand_the_state_provides_interview_prep_workshops_could_you_help_me_enroll_in_one_of_them:
      'Yes, I understand the state provides interview prep workshops. Could you help me enroll in one of them?',
    absolutely: 'Absolutely!',
    thank_you_so_much: 'Thank you so much!',
    can_you_tell_me_about_the_eap_program:
      'Can you tell me about the EAP program?',
    no_that_would_be_it_youve_been_really_great_thank_you_so_much_for_your_help:
      "No that would be it, you've been really great! Thank you so much for your help!",
    you_are_very_welcome_thank_you_for_contacting_state_and_have_a_nice_day:
      'You are very welcome, thank you for contacting State and have a nice day',

    // Interactions - NextGen1
    hi_connor_i_see_that_you_were_just_on_our_website_looking_at_our_2_year_upgrade_tradein_program_it_looks_like_your_phone_is_just_about_2_years_old_are_you_looking_to_upgrade_it:
      'Hi Connor, I see that you were just on our website looking at our 2-year Upgrade & Trade-in program. It looks like your phone is just about 2 years old, are you looking to upgrade it?',
    im_not_sure_yet: "I'm not sure yet",
    does_nextgen_have_the_phonolo_15: 'Does NextGen have the Phonolo 15?',
    good_to_know: 'Good to know',
    can_you_tell_me_about_the_phonolo_15s_camera:
      "Can you tell me about the Phonolo 15's camera?",
    hey_im_sorry_my_sisters_at_the_door_i_need_to_step_away_i_guess_i_can_go_back_to_your_website_to_chat_with_someone_later:
      "Hey, I'm sorry, my sister's at the door, I need to step away. I guess I can go back to your website to chat with someone later?",
    i_totally_understand_id_be_glad_to_send_you_a_text_message_to_schedule_a_better_time_for_us_to_chat:
      "I totally understand. I'd be glad to send you a text message to schedule a better time for us to chat?",
    yeah_thatd_be_great_thanks: "Yeah, that'd be great! Thanks!",

    // Interactions - NextGen2
    hi_connor_its_good_to_chat_again_is_this_a_better_time_for_you:
      "Hi Connor, it's good to chat again. Is this a better time for you?",
    now_works: 'Now works',
    great_earlier_today_we_were_talking_about_a_potential_phone_upgrade_and_the_new_phonolo_15s_great_camera_features_i_know_that_photography_is_a_hobby_of_yours_its_one_of_mine_too_and_i_promise_you_will_not_be_disappointed:
      "Great! Earlier today we were talking about a potential phone upgrade and the new Phonolo 15's great camera features. I know that Photography is a hobby of yours, it's one of mine too and I promise, you will not be disappointed!",
    _what_other_questions_can_i_answer_for_you:
      'What other questions can I answer for you?',
    how_much_is_the_phonolo_15: 'How much is the Phonolo 15?',
    do_you_have_any_promotions_on_phones:
      'Do you have any promotions on phones?',
    what_tablets_do_you_have: 'What tablets do you have?',
    ive_been_looking_at_the_iron_tablet_:
      "I've been looking at the Iron Tablet ...",
    id_like_to_go_ahead_with_the_promotion_can_you_help_me_with_that:
      "I'd like to go ahead with the promotion. Can you help me with that?",
    is_there_anything_else_i_can_help_you_with_today_connor:
      'Is there anything else I can help you with today Connor?',
    no_youve_been_great_thank_you_for_your_help:
      "No, you've been great. Thank you for your help!",

    // Interactions - NextGen_B_Demo1
    hi_sarah_my_name_is_ellie_thank_you_for_your_home_internet_business_i_understand_that_youre_looking_to_move_5_mobile_lines_to_nextgen_today:
      "Hi Sarah, my name is Ellie. Thank you for your home internet business! I understand that you're looking to move 5 mobile lines to NextGen today?",
    yes_but_i_forgot_to_ask_a_question: 'Yes, but I forgot to ask a question',
    do_you_have_a_family_calling_plan: 'Do you have a family calling plan?',
    _thats_great_and_can_you_tell_me_about_the_phonolo_15s_ai_features:
      "That's great. And can you tell me about the Phonolo 15's AI features?",
    what_if_my_kids_lose_their_device: 'What if my kids lose their device?',
    do_you_offer_insurance_on_phones_and_tablets:
      'Do you offer insurance on phones and tablets?',
    we_do_and_its_the_same_insurance_provider_that_youve_already_used_to_replace_your_router_based_on_the_ratings_you_gave_them_it_seems_like_that_was_a_good_experience_for_you:
      "We do, and it's the same insurance provider that you've already used to replace your router. Based on the ratings you gave them, it seems like that was a good experience for you.",
    i_think_id_like_to_go_ahead_and_port_my_5_mobile_lines:
      "I think I'd like to go ahead and port my 5 mobile lines.",
    thats_great_ill_be_glad_to_help_you_with_that_i_see_that_you_have_those_lines_on_two_carriers_which_is_the_first_carrier:
      "That's great! I'll be glad to help you with that. I see that you have those lines on two carriers? Which is the first carrier?",
    onetelecom: 'OneTelecom',
    and_how_many_lines_do_you_have_with_them:
      'And how many lines do you have with them?',
    three_do_you_need_the_numbers: 'Three. Do you need the numbers?',
    yes_please: 'Yes please',
    theyre_2153690310_2153690970_and_2153690160:
      "They're 215-369-0310, 215-369-0970 and 215-369-0160",
    and_will_you_be_purchasing_the_same_phones_and_tablets_for_those_3_lines:
      'And will you be purchasing the same phones and tablets for those 3 lines?',
    yes_the_phonolo_15_and_iron_tablet: 'Yes, the Phonolo 15 and Iron tablet',
    thank_you_we_can_start_there: 'Thank you, we can start there!',
    thank_you_so_much_for_your_help: 'Thank you so much for your help!',
    ive_heard_youre_going_to_be_offering_free_streaming_can_you_tell_me_more_about_that:
      "I've heard you're going to be offering free streaming? Can you tell me more about that?",
    unfortunately_i_dont_have_any_information_about_free_streaming:
      "Unfortunately, I don't have any information about free streaming...",

    // Interactions - NextGen_B_Demo2
    hi_mr_ellis_my_name_is_paul_thank_you_for_being_a_loyal_mobile_internet_customer_of_ours_how_can_i_help_you_today:
      'Hi Mr. Ellis, my name is Paul. Thank you for being a loyal mobile & internet customer of ours. How can I help you today?',
    you_mentioned_that_possibility_a_while_back_you_work_as_a_video_editor_correct:
      'You mentioned that possibility a while back. You work as a video editor, correct?',
    yeah_thats_right_i_do_a_lot_of_video_conferences_and_video_streaming_what_internet_package_do_you_recommend:
      "Yeah, that's right ... I do a lot of video conferences and video streaming. What internet package do you recommend?",
    how_can_i_do_a_speed_test_to_see_what_speed_im_getting_today:
      "How can I do a speed test to see what speed I'm getting today?",
    im_getting_only_30_mbps: "I'm getting only 30 Mbps",
    it_looks_like_i_need_to_upgrade_my_internet_can_you_help_me_with_that:
      'It looks like I need to upgrade my internet. Can you help me with that?',
    of_course: 'Of course!',
    ive_been_looking_at_upgrading_our_mobile_phones:
      "I've been looking at upgrading our mobile phones.",
    i_can_see_that_you_were_researching_the_new_phonolo_15_about_2_months_ago_its_a_significant_upgrade_over_the_phonolo_13_you_and_your_wife_currently_have:
      "I can see that you were researching the new Phonolo 15 about 2 months ago. It's a significant upgrade over the Phonolo 13 you and your wife currently have.",
    yes_it_certainly_looks_like_it_the_ai_features_are_intriguing:
      'Yes, it certainly looks like it! The AI features are intriguing.',
    do_you_have_any_promotions_on_phones_right_now:
      'Do you have any promotions on phones right now?',
    im_not_sure_were_interested_in_another_tablet_right_now:
      "I'm not sure we're interested in another tablet right now.",
    do_you_offer_monthly_payment_plans_for_phones:
      'Do you offer monthly payment plans for phones?',
    thats_good_to_know_let_me_talk_to_my_wife_about_it:
      "That's good to know! Let me talk to my wife about it.",
    of_course_is_there_anything_else_i_can_help_you_with_today:
      'Of course! Is there anything else I can help you with today?',
    you_are_very_welcome_have_a_great_day_mr_ellis:
      'You are very welcome, have a great day Mr. Ellis!',

    hooNotification: 'According to the hours of operation, this skill is not open. Are you sure you want to continue?',
    networkStatus: 'Status da Rede',
    post: 'Postar',
    startDate: 'Data de início',
    endDate: 'Data de término',
    invalidDate: 'Data inválida',
    reportingIntervalError: 'O intervalo de relatório não pode exceder 30 dias',
    answeringMachine: 'Secretária Eletrônica',
    badNumber: 'Número incorrecto',
    faxMachine: 'Fax',
    complete: 'Concluir',
    workItem: 'Item de Trabalho',
    windowUsedForEstablishingVoicePath: 'Esta janela é usada para estabelecer o caminho de voz. Não a feche',
    select: 'Selecionar',
    appleAppsReviews: 'Apple Apps Reviews',
    youtube: 'Youtube',
    googlePlay: 'Google Play',
    googlePlaces: 'Google Places',
    upload: 'Carregar',
    allowMicroPhonePermission: 'Clique aqui para permitir o uso do microfone',
    genericErrorMessage: 'Alguma coisa deu errado. Não é possível recuperar os dados.',
    contactInfo: 'Info de Contato',
    createDate: 'Data de criação',
    unread: 'Não lido',
    apply: 'Aplicar',
    customerField1: 'Campo do Cliente 1',
    customerField2: 'Campo do Cliente 2',
    address: 'Endereço',
    callerID: 'Identificação de chamadas',
    city: 'Cidade',
    compliance: 'conformidades Necessárias',
    externalID: 'ID Externo',
    score: 'Pontuação',
    state: 'Estado',
    zip: 'CEP',
    confirmationRequired: 'Confirmação Necessária',
    maximumRowSelection: 'a seleção de linhas é o máximo permitido',
    am: 'AM',
    pm: 'PM',
    me: 'Eu',
    selectionOptions: 'Opções de seleção',
    assignToMe: 'Atribuir a mim',
    assignToSomeoneElse: 'Atribuir a outra pessoa',
    noteLabel: 'Nota:',
    assignDigitalContact: 'Contato digital atribuído com sucesso: {x}',
    unableToAssignDigitalContact: 'Não é possível atribuir o contato digital: {x}',
    endCall: 'Encerrar chamada',
    leave: 'Sair',
    conferenceMenu: 'Menu de conferência',
    tag: 'Etiquetas',
    firstTag: 'Clique em Adicionar novo para adicionar a primeira tag',
    cannotDisconnectWithActiveCall: 'Não é possível desconectar com uma chamada ativa',
    invalidSubjectError: 'Insira um assunto válido',
    agentTimer: 'Temporizador do agente',
    customerTimer: 'Temporizador do cliente',
    maxConferenceLimitMessage: 'Limite máximo de conferência atingido. Não é possível adicionar outra chamada.',
    genericErrorMessageForDFO: 'Ops! Algo deu errado! Tente novamente ou entre em contato com o administrador do sistema.',
    amount: 'Valor',
    enterAmount: 'Inserir valor',
    dialAndMerge: 'Discar e mesclar',
    timer: 'Temporizador',
    agentLabel: 'Agente',
    messageTags: 'Tags de mensagem',
    pendingContactsInQueue: 'Você tem contatos pendentes na fila pessoal. Tem certeza que deseja fazer log out?',
    inboxAssignee: 'Cessionário da caixa de entrada',
    ownerAssignee: 'Proprietário cessionário',
    createdDateRange: 'Intervalo de datas de criação',
    channelName: 'Nome do canal',
    filterOptions: 'Opções de Filtro',
    addNew: 'Adicionar Novo',
    genericError: 'Ops! Algo deu errado! Tente novamente ou entre em contato com o administrador do sistema.',
    dateTime: 'Data/Hora',
    consultCallError: 'Não foi possível consultar um agente',
    dialSkillError: 'Não foi possível discar a competência',
    holdContactError: 'Não foi possível colocar o contato em espera',
    dialCallError: 'Não foi possível discar a chamada',
    transferCallError: 'Não foi possível transferir o contato',
    unpin: 'Desafixar:',
    pin: 'Fixar:',
    multiParty: 'Vários participantes',
    unableToFetchDispositions: 'Não foi possível buscar as disposições',
    dispositionPermissionError: 'Permissões insuficientes para definir a disposição dos resultados',
    cannotDisconnectVoiceMail: 'Não é possível desligar com voicemail ativo',
    requeue: 'Recolocar na fila',
    snooze: 'Adiar',
    popIn: 'Pop In',
    popOut: 'Pop Out',
    refused: 'Recusado',
    unableToAssignClosedDigitalContact: 'Os casos em estado encerrado: {x} não serão atribuídos',
    unableToAssignAlreadyAssignedContact: 'Casos: {x} já atribuídos ao designado selecionado',
    callPlaced: 'Chamada efetuada',
    answeredCall: 'Chamada atendida',
    busy: 'Ocupado',
    fax: 'Fax',
    intercept: 'Intercetar',
    noAnswer: 'Não atende',
    callEnded: 'A chamada terminou',
    naturalCallingListIsEmpty: 'Aguarde, o sistema está a identificar os melhores registos para ligar.',
    naturalCallingListRunningLow: 'O inventário de registos para a competência está reduzido.',
    chooseOutcome: 'Escolher resultado',
    noDigitalCaseinQueue: 'Sem interações digitais na fila',
    noPhoneCallsinQueue: 'Sem chamadas na fila',
    currentInteraction: 'Interação atual',
    firstResponseTime: 'Tempo de primeira resposta',
    resolutionTime: 'Tempo de resolução',
    context: 'Contexto',
    caseId: 'ID do caso',
    greaterThanTodayError: 'A data não deve ser posterior a hoje',
    unableToRetrieveAutoSummary: 'Não é possível obter o AutoSummary',
    autoSummaryCompleted: 'AutoSummary concluído',
    autoSummaryBeingGenerated: 'AutoSummary a ser gerado. Poderá editar as notas quando estiver concluído.',
    autoSummaryError: 'Erro de AutoSummary',
    autoSummaryNotAvailable: 'AutoSummary não disponível',
    autoSummaryWillGenerate: 'O AutoSummary será gerado após esta interação terminar',
    transferVoicemailSkill: 'Voicemail transferido com êxito',
    transferWorkItemSkill: 'Item de trabalho transferido com êxito',
    unableToTransferVoicemailSkill: 'Não é possível transferir competência de voicemail',
    unableToTransferWorkItemSkill: 'Não é possível transferir competência de item de trabalho',
    channelType: 'Tipo de canal',
    youPerformance: 'Você',
    teamPerformance: 'Equipa',
    percentagePerformance: '% da equipa',
    duration: 'Duração',
    dial: 'Marcar',
    redial: 'Remarcar',
    searchByCaseId: 'Procurar por ID de caso',
    typePhoneNumberHere: 'Escrever número de telefone',
    loadMoreOptions: 'Carregar mais',
    searchLimitExceeded: 'Limite de pesquisas excedido',
    noResultFound: 'Nenhum resultado encontrado',
    assignedSkills: 'Competências atribuídas',
    skillNotSupported: 'Esta competência não é suportada',
    unableToSendMessage: 'Não é possível enviar a mensagem',
    okay: 'OK',
    loadPreviousMessages: 'Carregar mensagens anteriores',
    viewRecentMessages: 'Ver mensagens diferentes',
    allMediaTypes: 'Todos os tipos de multimédia',
    mediaType: 'Tipo de multimédia',
    relatedInteractions: 'Interações relacionadas',
    telemetricData: 'Dados de telemtetria',
    processorName: 'Nome do processador',
    cpuUsage: 'Utilização de CPU',
    memoryUsage: 'Utilização de memória',
    memoryUnit: 'GB',
    searchByContent: 'Pesquisar conteúdo',
    content: 'Conteúdo',
    caseID: 'ID do caso',
    notAvailable: 'Não disponível',
    dropFiles: 'Largue os ficheiros aqui',
    retry: 'Repetir',
    replyTo: 'responder a',
    noSkillsAvailable: 'Nenhuma competência disponível',
    customerCardUpdateFailError: 'Não foi possível atualizar os detalhes do cliente.',
    previous: 'Anterior',
    attachmentNotSent: 'Anexo não enviado, tente novamente.',
    copilotUnavaliableMessage: 'Copilot indisponível',
    copilotReconnectMessage: 'A tentar ligar novamente',
    partiesMerged: 'Partes unidas',
    swap: 'Trocar chamador',
    cxoneWem: 'CXone WEM',
    reset: 'Redefinir',
    emailAddress: 'Endereço de e-mail',
    oneEmailErrorText: 'Só é permitido um endereço de e-mail',
    sending: 'A enviar',
    transcriptSuccess: 'Transcrição enviada com êxito.',
    transcriptFailure: 'Não é possível enviar a transcrição.',
    statusChangeText: '{x} interações selecionadas terão o seu estado alterado para {x}',
    statusChangeNotification: '{x} casos a alterar para o estado {x}',
    dismiss: 'Ignorar',
    readAt: 'Lido a',
    readStatus: 'Estado de leitura',
    author: 'Autor',
    showMessage: 'Mostrar mensagem',
    attachments: 'Anexos',
    idOnExternalPlatform: 'ID na plataforma externa',
    filterOptionsCount: 'A mostrar {x} de {x}',
    assignLoadingNotification: 'A atribuir {x} caso(s)',
    downloadTranscript: 'Transferir transcrição',
    seeTranslation: 'Ver tradução',
    seeOriginal: 'Ver original',
    hideTranslation: 'Ocultar tradução',
    hideOriginal: 'Ocultar original',
    translateMessages: 'Traduzir mensagens',
    translationOptions: 'Opções de tradução',
    customerLanguage: 'Idioma do cliente',
    myLanguage: 'O meu idioma',
    translateCustomerMessages: 'Traduzir mensagens de clientes',
    translateMyReplies: 'Traduzir as minhas respostas',
    showNextBestResponses: 'Mostrar as próximas melhores respostas',
    hideNextBestResponses: 'Ocultar as próximas melhores respostas',
    lastActivity: 'Última atividade',
    closedCasePartOne: 'O estado de',
    closedCasePartTwo: 'interação(ões) não pode ser modificado.',
    statusChangeMessage: 'O estado das interações selecionadas ({x} no total) será alterado para',
    sendingBulkReply: 'Envio de resposta em massa para {x} interação(ões)',
    bulkReplySentSuccessfully: 'Resposta enviada com sucesso para {x} interação(ões)',
    unableToSendBulkReply: 'Não foi possível responder a {x} interação(ões)',
    scheduledBulkReply: '{x} interação(ões) ainda está(ão) a ser enviada(s)',
    chatFingerprint: 'Impressão digital de chat',
    os: 'SO',
    browser: 'Browser',
    language: 'Idioma',
    ip: 'IP',
    country: 'País',
    deviceType: 'Tipo de dispositivo',
    deviceToken: 'Token de dispositivo',
    applicationType: 'Tipo de aplicação',
    noChatfingerprintDataMessage: 'Não estão disponíveis dados de impressão digital de chat',
    loggingConfiguration: 'Configuração do registo',
    logLevel: 'Nível de registo',
    digitalSearchQueryUnsupported: 'A consulta de pesquisa atual não é suportada. Tente alterar os parâmetros ou substituir quaisquer condições E/OU.',
    closedCaseAssignmentMessage: 'As interações fechadas não podem ser atribuídas. Anule a seleção para continuar.',
    assignToOthers: 'Atribuir a outros',
    closedStatusChangeError: 'As interações fechadas não podem alterar o seu estado. Desmarque a seleção para continuar.',
    insertTable: 'Inserir tabela',
    rows: 'Linhas',
    confirm: 'Confirmar',
    bgColor: 'Cor de fundo',
    below: 'abaixo de',
    above: 'acima de',
    left: 'esquerda',
    right: 'direita',
    deleteRow: 'Excluir linha',
    deleteColumn: 'Excluir coluna',
    deleteTable: 'Eliminar tabela',
    rowHeader: 'cabeçalho da linha',
    columnHeader: 'cabeçalho da coluna',
    addInlineImage: 'Inserir imagens',
    noOfRowsColumns: 'Valor entre 1-50',
    unsupportedImageTypeErrorMessage: 'Tipo de imagem não suportado, por favor insira apenas imagens',
    hasNote: 'Possui Nota',
    translationLicenseNotAvailable: 'A licença para a tradução de mensagens não está ativada. Contacte o seu representante de conta.',
    webSocketReconnect: 'A tentar restabelecer a ligação para obter atualizações em tempo real. Pode haver algum atraso.',
    webSocketConnected: 'Ligação restabelecida com êxito. Agora receberá as atualizações em tempo real.',
    WebSocketReconnectUnsuccessful: 'Infelizmente, a tentativa de restabelecer ligação falhou. Tente atualizar a página após algum tempo.',
    removed: 'Removido',
    caseto: 'caso para',
    caseFrom: 'caso de',
    assigned: 'Atribuído',
    setCaseAs: 'Definir caso como',
    opened: 'Aberto',
    reopened: 'Reaberto',
    of: 'de',
    interactionHistory: 'Histórico de interações',
    permissionDenied: 'Não tem permissão para ver esta secção.',
    contactYourAdmin: 'Verifique a sua configuração ou contacte o seu administrador.',
    likelihoodToBuy: 'Probabilidade de compra',
    overallSentimentScore: 'Pontuação global de sentimento',
    suggestionSummary: 'Resumo de sugestões',
    noSuggestionYet: 'Ainda não há sugestões',
    guidanceScores: 'Pontuações de orientação',
    landingMessage: 'À espera da autenticação...',
    permissionRequired: 'Permissões necessárias',
    permissionHelpPhrase: 'Precisa de privilégios para ver esta página. Contacte o seu administrador.',
    speechVelocity: 'Velocidade de fala',
    activeListening: 'Escuta ativa',
    beEmpathetic: 'Ser empático',
    interruption: 'Interrupção',
    demonstrateOwnership: 'Demonstrar propriedade',
    buildRapport: 'Criar relação',
    setExpectations: 'Definir expectativas',
    effectiveQuestioning: 'Questionamento eficaz',
    promoteSelfService: 'Promover o autosserviço',
    acknowledgeLoyalty: 'Reconhecer a fidelização',
    inappropriateAction: 'Ação inadequada',
    noScore: 'Sem PONTUAÇÃO',
    acknowledgeRequest: 'Confirmar pedido',
    askForTheSale: 'Pedir a venda',
    demonstrateEmpathy: 'Demonstrar empatia',
    makeAConnection: 'Estabelecer uma ligação',
    orderConfirmation: 'Encomenda confirmada',
    overcomeObjections: 'Ultrapassar objeções',
    presumptiveSelling: 'Venda presumida',
    uncoverNeeds: 'Descobrir necessidades',
    noKnowledgeArticles: 'Sem sugestões de artigos de base de conhecimento',
    smartReply: 'Resposta inteligente',
    bulkReplyText: 'A mensagem de resposta acima será enviada para as interações selecionadas. Note que será criada uma nova interação para quaisquer',
    lowerCaseInteractions: 'interações',
    previewNotSupported: "Preview mode isn't supported for this case, as it is a legacy record",
    noDataAvailable:'No data available',
    createDateRange: 'Create Date Range',
    noResultsFound: 'No results found',
    searchTag:'Tag',
    changeStatus: 'Change Status',
    endDateGreaterThanStartError:'Start date must be on or before the end date',
    api:'api',
    system:'system',
    messageNotSent: 'Message delivery failed. Please retry sending.',
    meeting: "REUNIÃO",
    break: "INTERVALO",
    itLooksLike: 'Parece que',
    wouldLikeTo: 'gostaria de',
    webChat: 'Chat na Web',
    custService: 'Serv. ao Cliente',
    custServiceRequest: 'Solicitação de Serv. ao Cliente',
    
    // Adaptive cards translations
    adp_noSuggestionFoundDescription : 'Faça perguntas ao Copilot para ajudar a escrever uma resposta.',
    adp_emailGeneratorDownDescription : 'Tente regenerar as respostas.',
    adp_replyGeneratedDescription : 'Uma mensagem de e-mail foi gerada e inserida no campo de resposta para sua revisão.',
    adp_generateEmailDescription : 'O Copilot pode gerar uma resposta para este e-mail para você revisar e alterar. Como você gostaria que este e-mail fosse gerado?',
    adp_replyGeneratingDescription : 'Aguarde alguns segundos, o Copilot está trabalhando na sua resposta gerada.',
    adp_responseTopics: 'Tópicos de Resposta Identificados',
    adp_addTopic: 'Adicionar Tópicos',
    adp_responseLength: 'Selecionar comprimento da resposta',
    adp_responseLengthLong: 'Longa',
    adp_responseLengthShort: 'Curta',
    adp_enterNewTopic: 'Inserir Novo Tópico',
    adp_selectTopicMessage: 'Selecione pelo menos um tópico para gerar uma resposta de e-mail',
  },
};